import { NewButtonComponent } from "../../atoms/buttonComponent";
import { ButtonListContainer } from "./style";

export const ButtonListContainerComponent = (props) => {
    return <ButtonListContainer {...props}>{props.items.map(i => (<NewButtonComponent {...i}>{i.text}</NewButtonComponent>))}</ButtonListContainer>;
}
